/**
 * Extract tweet ID from a Twitter/X URL.
 * Supports: twitter.com, x.com, www prefix, /i/status/ format, query params.
 * Returns null if URL is not a valid tweet link.
 */
export function extractTweetId(url) {
  if (!url || typeof url !== 'string') return null;
  const trimmed = url.trim();
  const match = trimmed.match(
    /^https?:\/\/(?:www\.)?(?:twitter\.com|x\.com)\/(?:\w+)\/status(?:es)?\/(\d+)/
  );
  return match ? match[1] : null;
}

/**
 * Check if a string is a tweet URL (standalone, no extra text).
 */
export function isTweetUrl(text) {
  if (!text || typeof text !== 'string') return false;
  return extractTweetId(text.trim()) !== null;
}
